import { StylesConfig } from "react-select";

export const selectStyles: StylesConfig = {
  control: (styles) => ({ ...styles, height: "100%" }),
  placeholder: (styles) => ({
    ...styles,
    color: "#536493",
  }),
  singleValue: (styles) => ({
    ...styles,
    color: "#536493",
  }),
  option: (styles, { isSelected }) => {
    return {
      ...styles,
      color: isSelected ? "#536493" : "#536493",
    };
  },
  indicatorsContainer: (styles) => ({
    ...styles,
    color: "#536493",
  }),
  multiValue: (styles) => ({
    ...styles,
    backgroundColor: "#536493",
    borderRadius: "4px",
  }),
  multiValueLabel: (styles) => ({
    ...styles,
    color: "#ffffff",
    fontWeight: 600,
  }),
  multiValueRemove: (styles) => ({
    ...styles,
    color: "#ffffff",
    ":hover": {
      backgroundColor: "#3d4a6e",
      color: "#ffffff",
    },
  }),
};

export const multiSelectStyles: StylesConfig = {
  ...selectStyles,
  control: (styles) => ({ ...styles, minHeight: "100%", height: "auto" }),
};

export const iconSelectStyles: StylesConfig = {
  control: (provided: any, state: any) => ({
    ...provided,
    minHeight: "48px",
    border: (() => {
      const hasError = !!state?.selectProps?.className?.includes("error");
      if (hasError) return "2px solid #ef4444";
      return `2px solid ${state.isFocused ? "#113F67" : "#e5e7eb"}`;
    })(),
    borderRadius: "8px",
    backgroundColor: "white",
    boxShadow: (() => {
      const hasError = !!state?.selectProps?.className?.includes("error");
      if (state.isFocused && hasError)
        return "0 0 0 2px var(--tw-ring-offset-color, #fff), 0 0 0 4px rgb(239 68 68 / 1)";
      if (state.isFocused)
        return "0 0 0 2px var(--tw-ring-offset-color, #fff), 0 0 0 4px rgb(17 63 103 / 1)";
      return "none";
    })(),
    outline: "2px solid transparent",
    outlineOffset: "2px",
    transition: "all 0.2s ease",
    "&:hover": {
      border: (() => {
        const hasError = !!state?.selectProps?.className?.includes("error");
        if (hasError) return "2px solid #ef4444";
        return `2px solid ${state.isFocused ? "#113F67" : "#d1d5db"}`;
      })(),
    },
  }),
  valueContainer: (provided: any) => ({
    ...provided,
    paddingLeft: "3rem",
    paddingRight: "0.75rem",
  }),
  placeholder: (provided: any) => ({
    ...provided,
    color: "#64748b",
    fontSize: "1rem",
  }),
  singleValue: (provided: any) => ({
    ...provided,
    color: "#0f172a",
    fontSize: "1rem",
  }),
  input: (provided: any) => ({
    ...provided,
    fontSize: "1rem",
  }),
  menu: (provided: any) => ({
    ...provided,
    zIndex: 9999,
  }),
  menuPortal: (provided: any) => ({
    ...provided,
    zIndex: 9999,
  }),
};

export const iconMultiSelectStyles: StylesConfig = {
  ...iconSelectStyles,
  placeholder: (provided: any) => ({
    ...provided,
    color: "#9ca3af",
    fontSize: "1rem",
  }),
  multiValue: (provided: any) => ({
    ...provided,
    backgroundColor: "#f3f4f6",
    borderRadius: "6px",
  }),
  multiValueLabel: (provided: any) => ({
    ...provided,
    color: "#374151",
    fontSize: "14px",
  }),
  multiValueRemove: (provided: any) => ({
    ...provided,
    color: "#6b7280",
    "&:hover": {
      backgroundColor: "#ef4444",
      color: "white",
    },
  }),
};

// The select on the cutting cards (the picker's sizes, the order form's bar sizes): react-select, as on every form, sized
// like the cards' boxes: 36px high with their 1px border and no field icon. Its menu can be portaled over a dialog, which
// would otherwise cut it off.
export const compactSelectStyles = <Option>(): StylesConfig<Option, false> => ({
  control: (provided, state) => ({
    ...provided,
    minHeight: "36px",
    height: "36px",
    borderRadius: "6px",
    borderColor: state.isFocused ? "#113F67" : "#d1d5db",
    boxShadow: state.isFocused ? "0 0 0 1px #113F67" : "none",
    backgroundColor: state.isDisabled ? "#f3f4f6" : "white",
    "&:hover": { borderColor: state.isFocused ? "#113F67" : "#9ca3af" },
  }),
  valueContainer: (provided) => ({ ...provided, padding: "0 0 0 10px" }),
  singleValue: (provided, state) => ({
    ...provided,
    fontSize: "0.875rem",
    fontWeight: 600,
    color: state.isDisabled ? "#6b7280" : "#0f172a",
  }),
  dropdownIndicator: (provided) => ({ ...provided, padding: "0 8px" }),
  menuPortal: (provided) => ({ ...provided, zIndex: 9999 }),
});

export const toastStyles = {
  position: "top-right",
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
};
